// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"184":"cf027a85","209":"a23e7bf8","357":"56495caf","401":"9f7f4054","402":"2ab1f039","461":"3468f2b2","574":"1f7cb747","591":"2fc8b178","618":"1e1a4779","662":"1b5283b5","750":"75bc3e62","787":"735a7c21","968":"4c4c75a8"}[chunkId] + ".chunk.js";
};